export interface VersionInfo {
  versionNumber: number;
}

const areVersionsDifferent = (oldVersion: number, newVersion: number) => oldVersion !== newVersion;

const isValidVersion = (version: any) => !isNaN(version);

export const checkForNewVersion = () => {
  const currentVersionVariable = process.env.REACT_APP_VERSION;

  if (
    currentVersionVariable !== undefined &&
    currentVersionVariable !== null &&
    currentVersionVariable !== ''
  ) {
    const currentVersion = parseInt(currentVersionVariable, 10);

    if (isValidVersion(currentVersion)) {
      fetch('/version.json')
        .then(response => response.json())
        .then(versionInfo => {
          if (
            versionInfo &&
            versionInfo.versionNumber &&
            isValidVersion(versionInfo.versionNumber)
          ) {
            if (areVersionsDifferent(currentVersion, versionInfo.versionNumber)) {
              window.location.reload(true);
            }
          } else {
            console.log('Version found in version.json is not valid');
          }
        })
        .catch(error =>
          console.log(`An error occurred while checking version.json: ${error.message}`)
        );
    } else {
      console.log('Version variable is not a number.');
    }
  } else {
    console.log('No valid version variable found.');
  }
};
